import Headers_vue_vue_type_script_setup_true_lang_default from "./Headers.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/blocks/response-block/components/Headers.vue
var Headers_default = Headers_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { Headers_default as default };

//# sourceMappingURL=Headers.vue.js.map